import { BsAlertCircle } from 'react-icons/bs';
import { IoIosArrowForward } from 'react-icons/io';

import { Form } from 'formik';
import styled from 'styled-components';

import { ReactComponent as BaseIconClose } from 'assets/images/icon-close.svg';
import Button from 'components/Buttons/Button';
import Field from 'components/Field';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: #332927;
  margin: 16px 0;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: #332927;
  margin: 16px 0;

  &:first-child {
    margin-top: 0;
  }
`;

export const TagPolicy: any = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 130%;
  color: #ff2525;

  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  background: #ffdfdf;
  border-radius: 14px;
`;

TagPolicy.Icon = styled(BsAlertCircle)`
  color: #ff2525 !important;
  height: 16px;
  width: 16px;
  margin-right: 4px;
`;

export const Link: any = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

Link.Text = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  color: #332927;
`;

Link.Arrow = styled(IoIosArrowForward)`
  font-size: 14px;
  margin-left: 5px;
  color: #332927;
`;

export const ConfirmButton: any = styled(Button)``;

ConfirmButton.Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
ConfirmButton.Label = styled.span`
  color: #fff;
  font-weight: 600;
`;
ConfirmButton.Price = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 5px;
`;
ConfirmButton.Total = styled.span`
  font-weight: 400;
  color: #fff;
`;
ConfirmButton.Value = styled.span`
  font-weight: 600;
  color: #fff;
`;

export const ButtonContainer = styled.section`
  width: 100%;
  padding: 8px 0 0;
`;

export const Header: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 16px;
`;

Header.Title = styled.h1`
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;
`;

Header.Close = styled.div``;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  box-shadow: 0 6px 10px 0 rgba(128, 98, 96, 0.16);
  background-color: #ffffff;
  border-radius: 100%;
  cursor: pointer;
`;

export const IconClose = styled(BaseIconClose)`
  width: 11px;
`;

export const StyledField = styled(Field)`
  margin-top: 8px;
`;

export const Spacer = styled.div`
  height: 8px;
`;
